/** Chưa có AI backend — quota cố định để dựng UI. */
export const mockAiQuota = {
  chatUsed: 2,
  chatTotal: 5,
  pronunciationUsed: 0,
  pronunciationTotal: 5,
};
